import { render, staticRenderFns } from "./SupplierEvaluate.vue?vue&type=template&id=6754da6b&scoped=true"
import script from "./SupplierEvaluate.vue?vue&type=script&lang=js"
export * from "./SupplierEvaluate.vue?vue&type=script&lang=js"
import style0 from "./SupplierEvaluate.vue?vue&type=style&index=0&id=6754da6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6754da6b",
  null
  
)

export default component.exports